// extracted by mini-css-extract-plugin
export default {"body":"body-acIz2DfM","fact":"fact-QO4zPMCs"};